<template>
  <app-chip
    class="bg-deco-100 text-deco-950"
    :icon="icon ? icon : undefined"
    :size="size"
  >
    <slot>
      {{ address[field] }}
    </slot>
  </app-chip>
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    size?: "small";
    address: DatabaseCompositeType<"address">;
    field?: keyof DatabaseCompositeType<"address">;
    icon?: string | false;
  }>(),
  { size: undefined, field: "label", icon: "ph:map-pin" },
);
</script>
